import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import GalleryGrid from '../components/GalleryGrid'
import CTASection from '../components/CTASection'

export default function Gallery() {
  return (
    <>
      <SEO
        title="Event Gallery | Wedding, Corporate & Stage Decor Photos — AS Elite Gatherings"
        description="Browse photos of weddings, corporate events, private parties, product launches and stage decoration by AS Elite Gatherings in Marthandam, Tamil Nadu."
        keywords="event photos Marthandam, wedding gallery Tamil Nadu, corporate event photos, stage decoration photos, event decoration gallery Kanniyakumari"
        path="/gallery"
      />
      <PageHero
        eyebrow="Our Work"
        title="A gallery of gatherings"
        text={
          <>
            A look at the <Link to="/services#wedding">weddings</Link>,{' '}
            <Link to="/services#corporate-events">corporate events</Link>,{' '}
            <Link to="/services#private-party">private parties</Link>,{' '}
            <Link to="/services#product-launch">product launches</Link> and{' '}
            <Link to="/services#stage-decoration">stages</Link> we've helped bring to life.
            Filter by category to browse.
          </>
        }
        image="/images/bg/bg6.webp"
      />
      <section className="section">
        <div className="container">
          <GalleryGrid />
        </div>
      </section>
      <CTASection />
    </>
  )
}
